import React from "react"
import style from "./variantEditModalTabel.module.scss"
import toPersianNumber from "../../../helpers/actions/toPersianNumber"
import { numberWithCommas } from "../../../helpers/actions/splitNumberWithComma"
import { CalculateMaxPrice } from "../../../actions/APIcalls"
import WarningError from './warningError'

const VariantEditModalTabel = (props) => {

    const handleCalculateMaxPrice = async () => {
        let res = await CalculateMaxPrice({ dkpc: props.data.dkpc })
    }
    return (<>
        <div className={style.tabel}>
            <div className={style.smallRow}>
                <div className={style.rowLabel}></div>
                <div className={style.rowLabel}>کمترین قیمت</div>
                <div className={style.rowLabel}>بیشترین قیمت</div>
            </div>
            <div className={style.bigRow}>
                <div className={style.header}>
                    <p className={style.salesPrice}>قیمت فروش</p>
                    <p className={style.profit}>خالص دریافتی</p>
                    <p className={style.pureIncome}>خالص دریافتی {props.type.includes('dk') ? 'دیجی‌کالا' : 'اسنپ‌شاپ'}</p>
                    <p className={style.axillaryCosts}>هزینه‌های جانبی</p>
                    <p className={style.packaging}>
                        <span>ارسال و بسته‌بندی</span>
                        <span className={style.tax}>(با احتساب مالیات)</span>
                    </p>
                    <p className={style.comission}>
                        <span>کمیسیون {props.type.includes('dk') ? 'دیجی‌کالا' : 'اسنپ‌شاپ'}</span>
                        <span className={style.tax}>(با احتساب مالیات)</span>
                    </p>
                    {props.hasPlatforCosts ? <p className={style.comission}>
                        <span>هزینه توسعه پلتفرم</span>
                        <span className={style.tax}>(با احتساب مالیات)</span>
                    </p>
                        :
                        null
                    }
                </div>
                <div className={style.colData}>
                    <p className={style.salesPrice} style={parseInt(props.data.minProfit.sellPrice) > parseInt(props.data.maxProfit.sellPrice) ? { color: '#D90C0C' } : null}>{toPersianNumber(numberWithCommas(props.data.minProfit.sellPrice))}</p>
                    <p className={style.profit}>{toPersianNumber(numberWithCommas((props.data.minProfit.sellPrice - props.data.minProfit[props.type]) - props.data.ancillaryCosts))}</p>
                    <p className={style.pureIncome}>{toPersianNumber(numberWithCommas(props.data.minProfit[props.type]))}</p>
                    <p className={style.axillaryCosts}>{toPersianNumber(numberWithCommas(props.data.ancillaryCosts))}</p>
                    <p className={style.packaging}>{toPersianNumber(numberWithCommas(props.data.minProfit.shipping))}</p>
                    <p className={style.comission}>{toPersianNumber(numberWithCommas(props.data.minProfit.commission))}</p>
                    {props.hasPlatforCosts ? <p className={style.comission}>{toPersianNumber(numberWithCommas(props.data.minProfit.platformCost))}</p> : null}
                </div>
                <div className={style.colData}>
                    <p className={style.salesPrice} style={parseInt(props.data.minProfit.sellPrice) > parseInt(props.data.maxProfit.sellPrice) ? { color: '#D90C0C' } : null}>{props.data.maxProfit && props.data.maxProfit.sellPrice ? toPersianNumber(numberWithCommas(props.data.maxProfit.sellPrice)) : '--'}</p>
                    <p className={style.profit}>{props.data.maxProfit && props.data.maxProfit.sellPrice && props.data.maxProfit[props.type] ? toPersianNumber(numberWithCommas((props.data.maxProfit.sellPrice - props.data.maxProfit[props.type]) - props.data.ancillaryCosts)) : '--'}</p>
                    <p className={style.pureIncome}>{props.data.maxProfit && props.data.maxProfit[props.type] ? toPersianNumber(numberWithCommas(props.data.maxProfit[props.type])) : '--'}</p>
                    <p className={style.axillaryCosts}>{toPersianNumber(numberWithCommas(props.data.ancillaryCosts))}</p>
                    <p className={style.packaging}>{props.data.maxProfit && props.data.maxProfit.shipping ? toPersianNumber(numberWithCommas(props.data.maxProfit.shipping)) : '--'}</p>
                    <p className={style.comission}>{props.data.maxProfit && props.data.maxProfit.commission ? toPersianNumber(numberWithCommas(props.data.maxProfit.commission)) : '--'}</p>
                    {props.hasPlatforCosts ? <p className={style.comission}>{toPersianNumber(numberWithCommas(props.data.maxProfit.platformCost))}</p> : null}
                </div>
            </div>
        </div>

        {((parseInt(props.data.minProfit.sellPrice) > parseInt(props.data.maxProfit.sellPrice)) || !props.hasLeafCatPercent) ? <div className={style.warningWrapper}>
            <button className={style.warningsBtn}>
                <span className={style.icon}>n</span>
                <p className={style.maxPriceText}>هشدارها</p>
            </button>

            <div className={style.errorWrapper}>
                {(parseInt(props.data.minProfit.sellPrice) > parseInt(props.data.maxProfit.sellPrice)) && <WarningError
                    index='0'
                    title='بازه نامعتبر'
                    texts={['با توجه به قیمت مرجع فعلی، کمترین قیمت بالاتر از بیشترین قیمت است و امکان قیمت‌گذاری وجود ندارد.', 'شما می‌توانید حداقل حاشیه سود را تغییر دهید و یا با تغییر قیمت مرجع، ربات به شکل خودکار تغییر بازه قیمت را انجام می‌دهد.']}
                />}
                {!props.hasLeafCatPercent && <WarningError
                    index={(parseInt(props.data.minProfit.sellPrice) > parseInt(props.data.maxProfit.sellPrice)) ? '1' : '0'}
                    title='بیشترین قیمت'
                    texts={['بیشترین قیمت فعلی دقیق نمی‌باشد. برای محاسبه دقیق بیشترین قیمت، کلیک کنید.', '(هشدار! این فرآیند مستلزم حداقل یکبار قیمت‌گذاری در لحظه ‌می‌باشد)']}
                    buttonAction={() => handleCalculateMaxPrice()}
                />}
            </div>
        </div>
            :
            <div className={style.warningWrapper}></div>
        }
    </>
    )
}

export default VariantEditModalTabel;

